import api from '@/api/teachbot';

const getTeachBotResponse = (context, msg) => new Promise(((resolve, reject) => {
  api.sendMessageToBot(msg)
    .then((response) => {
      context.commit('GET_BOT_RESPONSE', response.data);
      resolve(response.data);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

export default {
  getTeachBotResponse
};



// WEBPACK FOOTER //
// ./src/store/modules/teachbot/actions.js